import React from 'react';
import IndustryPageTemplate from '@/components/IndustryPageTemplate';
import { industryAds } from '@/config/ads';

const TravelAndTourism: React.FC = () => {
  return (
    <IndustryPageTemplate
      slug="travel-and-tourism"
      industry="Travel & Tourism"
      heroHeadline="Create interactive storytelling ads to drive deeper engagement and more bookings."
      heroSubheadline="Transport travelers to their dream destinations with immersive experiences that inspire action."
      section2Title="Travel decisions are visual and emotional."
      section2Content="Travelers don't book trips based on bullet points—they book based on how a destination makes them feel. Interactive ads let you showcase the experience: virtual tours, destination galleries, and immersive storytelling that sparks wanderlust."
      section3Title="Interactive ads outperform static formats in attention and click-through."
      section3Content="When potential travelers can explore destinations, browse itineraries, and visualize their trip, they engage more deeply and move faster toward booking. Interactive travel ads turn dreamers into bookers."
      section4Title="Ideal for airlines, hotels, destinations, tourism boards, and travel brands."
      section4Content="From luxury resorts to adventure travel, Adventive helps you create the immersive digital experiences that inspire travelers to book."
      heroImage="https://d64gsuwffb70l.cloudfront.net/69408eb499b5789ef7367cf9_1765838665701_a66fbf49.jpg"
      heroAd={industryAds.travelAndTourism1}
      section2Ad={industryAds.travelAndTourism2}
      section3Ad={industryAds.travelAndTourism3}
      accentColor="bg-cyan-100 text-cyan-700"
      stats={[
        { value: '3.5x', label: 'Engagement rate' },
        { value: '+72%', label: 'Time on ad' },
        { value: '2.1x', label: 'Booking intent' },
        { value: '45%', label: 'Lower CPA' },
      ]}
      benefits={[
        'Airlines and aviation',
        'Hotels and resorts',
        'Tourism boards and destinations',
        'Travel agencies and OTAs',
      ]}
    />
  );
};

export default TravelAndTourism;
